export const WIDGET_EVENTS = {
  DESTROY: "destroy-widget",
  INITIALIZE_BP: "bp-initialize-borrower-platform",
  REDIRECT: "redirect",
} as const;
